import { TextInput, PasswordInput, Anchor, Title, Text, Container, Button, Flex, Card, Box } from "@mantine/core";
import axios from "axios";
import React, { useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useForm } from "@mantine/form";
import { toast } from "react-hot-toast";
import useAuthStore from "@/store/useAuthStore";
import { APP_NAME } from "@/config";

export default function ResetPassword() {
  const navigate = useNavigate();
  // get url params code using react router dom
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const handleAuthInit = useAuthStore((state) => state.handleAuthInit);
  const [loading, setLoading] = useState(false);

  const form = useForm({
    initialValues: {
      password: "",
      passwordConfirmation: "",
    },
  });
  const handleSubmit = async (data) => {
    const { password, passwordConfirmation } = data;
    if (password !== passwordConfirmation) {
      toast.error("비밀번호가 일치하지 않습니다");
      return;
    }

    try {
      setLoading(true);
      const res = await axios({
        url: "/auth/reset-password",
        method: "POST",
        data: {
          code,
          password,
          passwordConfirmation,
        },
      });
      // console.log(res);
      toast.success("신규 비밀번호로 로그인되었습니다");
      handleAuthInit(res.data.jwt);
      navigate("/");
    } catch (error) {
      console.log(error);
      toast.error("비밀번호 변경에 실패했습니다");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={(theme) => ({ backgroundColor: theme.fn.rgba(theme.colors.brand[0], 0.3) })}>
      <Container size="xs">
        <Flex direction="column" justify="center" h={window.innerHeight}>
          <Card withBorder shadow="md" p={30} radius="md">
            <Title order={2} weight={900} ta="center" mb="xs">
              비밀번호 초기화
            </Title>
            <Text color="dimmed" size="sm" ta="center" mb="lg">
              신규 비밀번호를 입력해주세요
            </Text>

            <form onSubmit={form.onSubmit(handleSubmit)}>
              <PasswordInput
                label="신규 비밀번호"
                placeholder="신규 비밀번호를 입력해주세요"
                required
                {...form.getInputProps("password")}
              />

              <PasswordInput
                label="신규 비밀번호 확인"
                placeholder="신규 비밀번호를 다시 입력해주세요"
                required
                {...form.getInputProps("passwordConfirmation")}
              />
              <Button mt="sm" sx={{ float: "right" }} type="submit" loading={loading}>
                비밀번호 변경하기
              </Button>
            </form>
          </Card>
        </Flex>
      </Container>
    </Box>
  );
}
